<template>
  <d-container fluid class="main-content-container p-4">
    <!-- --- COLLAPSE --- --- -- -->
    <div>
      <b-button v-b-toggle.collapse-2 class="m-1 greenbutton"><i class="fas fa-filter mr-2 "></i> Filtrer le tableau
      </b-button>
      <!-- Element to collapse -->
      <b-collapse id="collapse-2" class="mb-4">
        <d-card class="card-small">
          <d-card-body class="px-4 pb-0">
            <d-input-group class="justify-content-center">
              <c-input type="price" class="w-25" label="Tolérance" currency="XAF" v-model="inconsistencyMargin"/>
              <c-button-spinner class="inline-btn ml-1 mt-3" variant="primary" :fetching="fetchingSearch"
                                @click="onSearchSubmit">
                <template slot="icon">
                  <i class="fa fa-search"></i>
                </template>
                Rechercher
              </c-button-spinner>
            </d-input-group>
          </d-card-body>
        </d-card>
      </b-collapse>
    </div>
    <d-card class="card-small">
      <d-card-header class="px-4 pb-0">
        <d-input-group class="justify-content-center">
          <c-input class="w-25" placeholder="Rechercher par identifiant, nom ou tél..." v-model="search"/>
        </d-input-group>
      </d-card-header>
      <d-card-body class="pt-0">
        <c-table :fetching="fetchingData" :table-data="filteredData" :fields="fields" :actions="actions" :per-page="50">
          <p class="text-center" slot="empty">Aucun compte incohérent trouvé.</p>
        </c-table>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import {Api, formatAmount, Toast} from "@/helpers"

export default {
  title: "Incohérence des comptes",
  data() {
    return {
      search: '',
      data: [],
      submitted: false,
      inconsistencyMargin: 0,
      fetchingSearch: false,
      fetchingData: false,

      fields: [
        {key: 'entity', label: 'Nom', sortable: true},
        {key: 'username', label: 'Identifiant', sortable: true},
        {key: 'phone_number_pretty', label: 'Num. de tél.', sortable: true},
        {key: 'created_at', label: 'Inscrit le', sortable: true},
        {key: 'status', label: 'Statut', sortable: true},
        {key: 'balance_pretty', label: 'Solde', sortable: true},
        {key: 'expected_pretty', label: 'Solde calc.', sortable: true},
        {key: 'difference_pretty', label: 'Diff.', sortable: true},
        {key: 'actions', label: 'Actions'},
      ],

      actions: [
        {
          type: 'white',
          icon: 'fas fa-exchange-alt',
          title: "Transactions du compte",
          handler: this.onRedirectToTransaction
        },
        {
          type: 'white',
          icon: 'fas fa-sync',
          title: "Synchroniser le solde",
          handler: this.onSync
        },
      ],
    }
  },
  computed: {
    filteredData() {
      const search = this.search.toLowerCase()
      return this.data.filter(item => {
        return item.entity.toLowerCase().includes(search)
          || item.balance.toLowerCase().includes(search)
          || item.expected.toLowerCase().includes(search)
          || item.difference.toLowerCase().includes(search)
          || item.username.toLowerCase().includes(search)
          || (item.phone_number && item.phone_number.includes(search))
          || (item.email && item.email.includes(search))
      })
    },
  },

  created() {
    Api.get('/role/list')
      .then(res => this.roleList = res.data.roles)
      .catch(err => this.error = err)
      .then(() => null)

    this.fetchingData = true
    Api.get('/scan/users')
      .then(res => this.data = res.data.map(this.mapItem))
      .catch(err => this.error = err)
      .then(() => this.fetchingData = false)
  },

  methods: {
    mapItem(item) {
      return {
        ...item,
        name: item.first_name + ' ' + item.last_name + (item.enabled ? '' : ' 🚫'),
        phone_number_pretty: item.phone_number ? formatAmount(item.phone_number) : '',
        balance_pretty: formatAmount(item.balance),
        expected_pretty: formatAmount(item.expected),
        difference_pretty: formatAmount(item.difference),
        status: item.verified ? "Vérifié" : "Non vérifié",
        statusVariant: item.verified ? "success" : "secondary",
        phone_number: item.phone_number ? item.phone_number : '',
        email: item.email ? item.email : '',
      }
    },
    onSearchSubmit() {
      this.fetchingSearch = true
      Api.postFormData('/scan/users', {margin: this.inconsistencyMargin})
        .then(res => this.data = res.data.map(this.mapItem))
        .catch(err => this.error = err)
        .then(() => this.fetchingSearch = false)
    },
    //redirect a user account to its transactions
    onRedirectToTransaction(item) {
      this.$router.push({name: 'transactions', query: {entity: 'USER', id: item.id}});
    },
    // Sync user's balance
    onSync(item) {
      Toast.loading(`Synchronisation du solde de l'utilisateur "${item.entity}"...`)
      Api.postFormData('/sync_balance/user', {user_id: item.id})
        .then(res => {
          const user = this.mapItem(res.data.user)
          this.data = this.data.filter(_item => _item.id !== item.id)
          Toast.success(`Le solde de l'utilisateur "${user.name}" a été synchronisé avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => Toast.loadingToast.goAway())
    },
  }
}
</script>

<style>
.greenbutton {
  background-color: #3CBE0A;
  border-color: none !important;
}
</style>
